export type ScanTimeEntry = {
    hours: string;
    minutes: string;
    seconds: string;
};

export const emptyScanTimeEntry: ScanTimeEntry = {
    hours: '',
    minutes: '',
    seconds: '',
};

export const initialScanTimeEntries: ScanTimeEntry[] = [
    emptyScanTimeEntry,
    emptyScanTimeEntry,
    emptyScanTimeEntry,
];

export function totalSeconds(entries: ScanTimeEntry[]): number {
    return entries.reduce(
        (sum, entry) =>
            sum +
            Number(entry.hours || 0) * 3600 +
            Number(entry.minutes || 0) * 60 +
            Number(entry.seconds || 0),
        0
    );
}
